<div class="mgmt-page">

  <!-- ── Page Header ── -->
  <div class="page-header">
    <div class="page-header__left">
      <span class="page-tag">CMS</span>
      <h1 class="page-title">Sliders</h1>
      <p class="page-sub">Manage homepage slider images and content</p>
    </div>
    <button class="btn-add" (click)="openModal()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      Add Slider
    </button>
  </div>

  <!-- ── Grid ── -->
  <div class="items-grid" *ngIf="items.length > 0; else emptyState">
    <div class="item-card" *ngFor="let item of items; let i = index"
         [style.animation-delay]="i * 0.06 + 's'">
      <div class="item-card__image">
        <img [src]="item.imageUrl |ImageUrlPipe" [alt]="item.title" *ngIf="item.imageUrl" />
        <div class="item-card__no-img" *ngIf="!item.imageUrl">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        </div>
        <span class="lang-badge">{{ item.languageCode }}</span>
      </div>
      <div class="item-card__body">
        <h3 class="item-card__title">{{ item.title || '—' }}</h3>
        <p class="item-card__desc">{{ item.description || 'No description provided.' }}</p>
        <a class="item-card__link" *ngIf="item.link" [href]="item.link" target="_blank">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
          {{ item.link }}
        </a>
      </div>
      <div class="item-card__actions">
        <button class="btn-icon btn-icon--edit" (click)="openModal(item)" title="Edit">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
        </button>
        <button class="btn-icon btn-icon--delete" (click)="confirmDelete(item)" title="Delete">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
        </button>
      </div>
    </div>
  </div>

  <!-- ── Empty State ── -->
  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-state__icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="7" width="20" height="15" rx="2"/><polyline points="17 2 12 7 7 2"/></svg>
      </div>
      <h3>No sliders yet</h3>
      <p>Add your first slider to get started</p>
      <button class="btn-add" (click)="openModal()">Add Slider</button>
    </div>
  </ng-template>

  <!-- ── Delete Confirm Modal ── -->
  <div class="overlay" *ngIf="showDeleteConfirm" (click)="showDeleteConfirm = false">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      </div>
      <h4>Delete Slider?</h4>
      <p>This action cannot be undone.</p>
      <div class="confirm-modal__actions">
        <button class="btn-cancel" (click)="showDeleteConfirm = false">Cancel</button>
        <button class="btn-danger" (click)="deleteItem()">Delete</button>
      </div>
    </div>
  </div>

  <!-- ── Add / Edit Modal ── -->
  <div class="overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="form-modal" (click)="$event.stopPropagation()">

      <div class="form-modal__header">
        <div>
          <span class="page-tag">{{ editingItem ? 'EDIT' : 'NEW' }}</span>
          <h3>{{ editingItem ? 'Edit Slider' : 'Add Slider' }}</h3>
        </div>
        <button class="modal-close" (click)="closeModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="form-modal__body">

        <!-- Language Code -->
        <div class="form-field">
          <label>Language Code</label>
          <div class="lang-selector">
            <button
              *ngFor="let lang of languages"
              class="lang-btn"
              [class.active]="form.languageCode === lang.code"
              (click)="form.languageCode = lang.code">
              <span class="lang-flag">{{ lang.flag }}</span>
              {{ lang.code }}
            </button>
          </div>
        </div>

        <!-- Title -->
        <div class="form-field">
          <label>Title</label>
          <input type="text" class="form-input" placeholder="Enter slider title…"
                 [(ngModel)]="form.title" />
        </div>

        <!-- Description -->
        <div class="form-field">
          <label>Description</label>
          <textarea class="form-input form-textarea" placeholder="Enter description…"
                    [(ngModel)]="form.description" rows="3"></textarea>
        </div>

        <!-- Link -->
        <div class="form-field">
          <label>Link URL</label>
          <input type="url" class="form-input" placeholder="https://example.com"
                 [(ngModel)]="form.link" />
        </div>

        <!-- Image Upload -->
        <div class="form-field">
          <label>Image</label>
          <div class="img-upload" [class.has-image]="imagePreview" (click)="fileInput.click()">
            <img [src]="imagePreview |imageUrl" *ngIf="imagePreview" alt="preview" />
            <div class="img-upload__placeholder" *ngIf="!imagePreview">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              <span>Click to upload image</span>
              <small>PNG, JPG, WEBP up to 5MB</small>
            </div>
            <button class="img-remove" *ngIf="imagePreview"
                    (click)="$event.stopPropagation(); removeImage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <input #fileInput type="file" accept="image/*" hidden (change)="onImageSelected($event)" />
        </div>

      </div>

      <div class="form-modal__footer">
        <button class="btn-cancel" (click)="closeModal()">Cancel</button>
        <button class="btn-save" [disabled]="saving" (click)="saveItem()">
          <span *ngIf="saving" class="spinner"></span>
          {{ saving ? 'Saving…' : (editingItem ? 'Update Slider' : 'Add Slider') }}
        </button>
      </div>

    </div>
  </div>

</div>